<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{tituloGrids}}</span>
      </v-col>
       <v-col md="12" sm="12" cols="12" class="pa-0 ma-0">
        <v-breadcrumbs
          class="py-2 px-0"
          :items="aItemsBreadcrumbs"
          divider=">"
        >
         <template v-slot:item="{ item }">
          <v-breadcrumbs-item class="titlesdark--text">
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <grid
          v-if="this.$store.state.token!=''"
          :tabla="TablaName"
          :bActiveFilter="true"
          :bActiveExport="true"
          :bSingleSelect="true"
          :bShowSelect="true"
          :sIdTable="'Id_Inspeccion_Preoperacional'"
          :bShowMapDetails="false"
          :bActiveNew="false"
          :aInfoTBDetalleExp="aDetallesExport"
          @saveOk="createDetaill"
          @idSelect="getIdSelect"
          @nameField="getNameFieldSelect"
          />
      </v-col>
      <v-col md="12" sm="12" cols="12" class="pa-0 ma-0 mt-2">
        <grid-detalle
          v-if="parseInt(nIdSeleccionado) > 0"
          :tabla="'COP_Respuestas_Parte_Moto_Inspeccion'"
          :sIdTable="'id_Partes_moto'"
          :bActiveFilter="false"
          :bActiveExport="false"
          :bSingleSelect="false"
          :bShowSelect="false"
          :bShowMapDetails="false"
          :bActiveSearch="false"
          :bActiveNew="false"
          :bGridDetalle="true"
          :nIdValor="parseInt(nIdSeleccionado)"
          :sCampoFiltro="'Id_Inspeccion_Preoperacional'"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import grid from '@/components/Grid/Grid.vue'
import mxFunciones from '@/mixins/funciones.js'
import GridDetalle from '@/components/Grid/Grid.vue'
// import DialogFirmas from '@/components/DialogFirmas.vue' 

export default {
  name: 'InspeccionPreoperacional',
  components: {
    grid,
    GridDetalle
  },
  mixins: [mxFunciones],
  data() {
    return {
      TablaName : 'COP_Inspeccion_Preoperacional',    // Nombre de la tabla a trabajar
      nIdSeleccionado  : 0,                 // Id seleccionado
      sNombreCampoFiltro : '',                 // Nombre del campo foreignKey
      aItemsBreadcrumbs: [
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlInicio,
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlModuloOperaciones,
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: '',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
      ],
      aDetallesExport : [
        { 
          sTablaDetalle: 'COP_Respuestas_Parte_Moto_Inspeccion',
          sNombreCampoFiltroDetalle: 'Id_Inspeccion_Preoperacional',
          sCampoParaFiltroTBPrincipal: 'Id_Inspeccion_Preoperacional',
        }
      ],
    }
  },
  async mounted() {
    this.onValidarTokenSinLogin()
    this.tituloGrids = await this.getTitulo(this.TablaName)
    this.aItemsBreadcrumbs[2].text = this.tituloGrids
  },
  methods: {
    getIdSelect(sIdSelected) {
      this.nIdSeleccionado = sIdSelected;
    },
    getNameFieldSelect(sNameFiled) {
      this.sNombreCampoFiltro = sNameFiled;
    },
    createDetaill() {
  
    },
  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>

</style>